<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <div
    :class="cn('px-2 pt-2 empty:hidden empty:p-0', props.class)"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>
